import { PaymentAgreement } from '../models/enums/index';

export const MAINTENACE_STATUS_MODAL_STRINGS = {
  responsibilityonhomeownerside: {
    title: 'Should we do\u00a0it?',
    homeownerpays: {
      text: 'You got it! We will charge your default payment\u00a0method.',
    },
    homeownerpaysWithUpfront: {
      text: 'You got it! <b>We will charge ${upfront} now</b> to your default payment method, and the rest deducted from rent upon\u00a0completion.',
    },
    renterpays: {
      title: 'Great! Looking to strengthen the relationship\u00a0further?',
    },
    renterpayshalf: {
      text: 'Nice! We’ll check in with your resident to see what they want to do and report\u00a0back.',
    },
    renterpaysfull: {
      text: 'No problem! We’ll ask your resident what they want to do and report\u00a0back.',
    },
    // hasNoRenterButDeclined: {
    //   text: 'Lorem Ipsum'
    // },
    denied: {
      text: 'No problem! May we ask what the primary reason was for making this\u00a0decision?',
    },
    // reasonwhynoupgrade: {
    //   // CAN'T BE SPANNED
    //   text: 'Make sense! We’ll let your Renter, {firstName}, know we won’t be making this change at this time.',
    // },
  },

  'maintenance.scheduled.title': 'Visits',

  'maintenance.scheduled.status.scheduled': 'Scheduled Visit',
  'maintenance.scheduled.status.cancelled': 'Cancelled Visit',
  'maintenance.scheduled.status.completed': 'Completed Visit',
  'maintenance.scheduled.status.completed.notresolved': 'Follow-up Required',

  'maintenance.inHomeRepairs.scheduled.status.scheduled': 'Visit Scheduled',
  'maintenance.inHomeRepairs.scheduled.status.cancelled': 'Visit Cancelled',
  'maintenance.inHomeRepairs.scheduled.status.completed': 'Visit Completed',
  'maintenance.inHomeRepairs.scheduled.status.completed.notresolved':
    'Follow-up Required',
  responsibilityonrenterside: {
    renterpayshalf: {
      title:
        'Would you like to move forward and split the cost with {homeownername}?',
    },
    renterpaysfull: {
      title: 'Would you like to move forward with this\u00a0upgrade?',
    },
  },

  maintenancecancelmodal: {
    title: 'Why do you want to cancel this\u00a0request?',
    inputplaceholder: 'Cancellation Reason',
    successfultitle: 'No problem!',
    successfultext: "We've gone ahead and cancelled this\u00a0request.",
  },

  // DO NOT CHANGE THE KEYS WITHOUT A DEV
  shouldDoIt: [
    {
      label: "Yes, I'll pay for\u00a0it.",
      key: PaymentAgreement.OwnerPays,
    },
    {
      label: 'Sure, if they pay for\u00a0it.',
      key: PaymentAgreement.ResidentPays,
    },
    {
      label: 'No, not at this\u00a0time.',
      key: PaymentAgreement.Declined,
    },
  ],

  // Refers to when HO is the same as the requester.
  shouldDoItHOisRequester: [
    {
      label: "Yes, I'll pay for\u00a0it.",
      key: PaymentAgreement.OwnerPays,
    },
    {
      label: 'No, not at this\u00a0time.',
      key: PaymentAgreement.Declined,
    },
  ],

  // Refers to when Resident is the same as the requester
  shouldDoItNoResident: [
    {
      label: "Yes, I'll pay for\u00a0it.",
      key: PaymentAgreement.OwnerPays,
    },
    {
      label: 'No, not at this\u00a0time.',
      key: PaymentAgreement.Declined,
    },
  ],

  renterSplitText: [
    {
      label: "Nope, they're on their\u00a0own.",
      key: PaymentAgreement.ResidentPays,
    },
    {
      label: "Sure, I'll split it with\u00a0them.",
      key: PaymentAgreement.SplitPayment,
    },
  ],
  estimatedCost: {
    pricingGuarantee: {
      title: 'Belong Price Guarantee',
      paragraph_1: `When work needs to be done,
      we here at Belong believe you should receive a fair price for the best quality work;
      work that lasts,
      providing you the most long-term value on your\u00a0home.`,
      paragraph_2: `Accordingly, Belong always charges fair rates on maintenance and upgrades. Rest assured, you're getting the most bang for your\u00a0buck.`,
    },
    delightfulGuarantee: {
      title: "Backed By Belong's Quality\u00a0Guarantee",
      paragraph_1:
        "If you're not completely delighted with the quality of our work, we'll do it again. On\u00a0us.",
    },
  },

  appointmentScheduledModal: {
    title: 'Visits',
  },

  'approvalAndResponsibility.title': 'Approval',
  lookingToSplit: {
    paragraph_1: 'Looking to <b>split</b> these into multiple\u00a0payments?\n',
    not_completed: 'You’ll be able to do so upon\u00a0completion.',
    completed: 'You’ll be able to do so on your next\u00a0bill.',
  },
  'included-in-plan': 'This is included in Split It Plan {financePlanId}.',
};
